(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const loadMoreBtn = document.querySelector('.collection-load-more-btn');
    const backToTopBtn = document.querySelector('.collection-back-to-top');

    if (backToTopBtn) {
      backToTopBtn.addEventListener('click', (event) => {
        event.preventDefault();

        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', async () => {
      const btn = loadMoreBtn;
      const nextPageUrl = btn.dataset.nextPage;
      const sectionId = btn.dataset.sectionId;

      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const fetchUrl = new URL(nextPageUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        const response = await fetch(fetchUrl.toString());
        if (!response.ok) throw new Error('Fetch failed');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newItems = doc.querySelectorAll('.product-grid__item');
        const grid = document.querySelector('[ref="grid"]');

        if (grid && newItems.length > 0) {
          newItems.forEach((item) => grid.appendChild(item.cloneNode(true)));
        }

        const nextBtn = doc.querySelector('.collection-load-more-btn[data-next-page]');
        if (nextBtn) {
          btn.dataset.nextPage = nextBtn.dataset.nextPage;
          btn.dataset.currentPage = nextBtn.dataset.currentPage;
          btn.disabled = false;
          btn.textContent = 'Load More';
        } else {
          btn.disabled = true;
          btn.textContent = 'End of results';
          btn.classList.remove('button', 'button--secondary');
          btn.classList.add('collection-load-more-btn--end');
        }
      } catch {
        btn.disabled = false;
        btn.textContent = 'Load More';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    if (window.__productMediaHoverScrollInit) return;
    window.__productMediaHoverScrollInit = true;

    const clearActiveStates = () => {
      document.querySelectorAll('.product-information__media.media-scroll-active').forEach((wrapper) => {
        wrapper.classList.remove('media-scroll-active');
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => clearActiveStates(), { once: true });
    } else {
      clearActiveStates();
    }

    document.addEventListener('shopify:section:load', () => {
      clearActiveStates();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
